(function() {
    const buttons = document.querySelectorAll('.countryButton');
    const dropdowns = document.querySelectorAll('.country-selector__dropdown');
    
    buttons.forEach((button, index) => {
        const dropdown = dropdowns[index];
        const chevron = button.querySelector('.chevron-down');
        const selectedCountry = button.querySelector('.selectedCountry');
        const options = dropdown.querySelectorAll('.country-selector__option');

        /**
         * Toggle the dropdown visibility
         */
        function toggleDropdown() {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !isExpanded;
            button.setAttribute('aria-expanded', nextExpanded);
            chevron.classList.toggle('active', nextExpanded);
            if (nextExpanded) {
                dropdown.removeAttribute('hidden');
                dropdown.classList.add('show');
            } else {
                dropdown.setAttribute('hidden', '');
                dropdown.classList.remove('show');
            }
        }

        /**
         * Close the dropdown menu
         */
        function closeDropdown() {
            button.setAttribute('aria-expanded', 'false');
            dropdown.setAttribute('hidden', '');
            dropdown.classList.remove('show');
            chevron.classList.remove('active');
        }

        /**
         * Handle keyboard navigation for accessibility
         */
        function handleKeyboard(event) {
            if (event.key === 'Escape') {
                closeDropdown();
                button.focus();
            } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                const currentIndex = Array.from(options).findIndex(option => option === document.activeElement);
                const nextIndex = event.key === 'ArrowDown' ? 
                    (currentIndex + 1) % options.length : 
                    (currentIndex - 1 + options.length) % options.length;
                options[nextIndex].focus();
            }
        }

        /**
         * Get the current domain and TLD
         */
        function getCurrentDomain() {
            return window.location.hostname;
        }

        /**
         * Get the current path of the URL (excluding domain)
         */
        function getCurrentPath() {
            return window.location.pathname + window.location.search;
        }

        /**
         * Get the TLD of the current website (.com, .ca, etc.)
         */
        function getCurrentTLD() {
            const domainParts = getCurrentDomain().split('.');
            return domainParts[domainParts.length - 1];
        }

        /**
         * Update the links for USA and Canada
         */
        function updateCountryUrls() {
            const currentPath = getCurrentPath();
            const currentDomain = getCurrentDomain();
            const tld = getCurrentTLD();
            const baseDomain = currentDomain.replace(`.${tld}`, '');

            options.forEach(option => {
                const country = option.getAttribute('data-country');
                let newUrl;

                // if (country === 'canada' && tld !== 'ca') {
                //     // Switch to .ca domain
                //     newUrl = `https://${baseDomain}.ca${currentPath}`;
                // } else if (country === 'usa' && tld !== 'com') {
                //     // Switch to .com domain
                //     newUrl = `https://${baseDomain}.com${currentPath}`;
                // } else {
                //     newUrl = window.location.href; // Stay on the same page
                // }
              
              if (country === 'canada' && tld !== 'ca') {
                    // Switch to .ca domain
                    newUrl = `https://${baseDomain}.ca`;
                } else if (country === 'usa' && tld !== 'com') {
                    // Switch to .com domain
                    newUrl = `https://${baseDomain}.com`;
                } else {
                    newUrl = window.location.href; // Stay on the same page
                }

                option.href = newUrl;
            });
        }

        /**
         * Set the initial country to display in the button
         */
        function setInitialCountry() {
            const tld = getCurrentTLD();
            const isOnCA = tld === 'ca';

            selectedCountry.textContent = isOnCA ? 'Canada' : 'USA';

            options.forEach(option => {
                if (option.getAttribute('data-country') === (isOnCA ? 'canada' : 'usa')) {
                    option.setAttribute('aria-current', 'true');
                } else {
                    option.removeAttribute('aria-current');
                }
            });
        }

        // Event listeners for UI interaction
        button.addEventListener('click', toggleDropdown);
        document.addEventListener('click', (event) => {
            if (!button.contains(event.target) && !dropdown.contains(event.target)) {
                closeDropdown();
            }
        });

        dropdown.addEventListener('click', (event) => {
            if (event.target.classList.contains('country-selector__option')) {
                selectedCountry.textContent = event.target.getAttribute('data-country').toUpperCase();
                closeDropdown();
            }
        });

        document.addEventListener('keydown', handleKeyboard);

        // Initialize the component
        setInitialCountry();
        updateCountryUrls();
    });
})();
